/**
 * Auspacken von CommonJS-Modulen.
 *
 * Vite 8 bündelt mit Rolldown, und Rolldown reicht ein CommonJS-Modul als
 *
 *     export default require_lib();
 *
 * weiter - also das gesamte `module.exports`-Objekt, ohne die Auszeichnung
 * `__esModule` auszuwerten. Ein `import x from 'paket'` liefert damit das
 * Objekt statt der Funktion dahinter, und benannte Importe fehlen ganz.
 *
 * Betroffen sind alle Abhängigkeiten ohne ESM-Ausgabe. Im Quelltext sind das
 * über 140 Dateien; deshalb wird nicht dort geändert, sondern die Auflösung
 * des Paketnamens auf einen Adapter umgebogen (siehe `resolve.alias` in
 * vite.config.ts). Der Adapter greift im Entwicklungsbetrieb **und** im Bau -
 * beide waren betroffen.
 */
export function auspacken<T>(modul: unknown): T {
  const m = modul as { default?: unknown; __esModule?: boolean };

  // Doppelt verpackt: Rolldown legt das Exportobjekt unter default ab, und
  // das Paket selbst hat dort noch einmal seine Hauptfunktion abgelegt.
  if (m && typeof m === 'object' && 'default' in m && m.default !== undefined) {
    return m.default as T;
  }

  return modul as T;
}
